import script from "./ColumnSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnSort.vue?vue&type=script&setup=true&lang=ts"

import "./ColumnSort.vue?vue&type=style&index=0&id=50ef824b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ef824b"]])

export default __exports__